import { Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import { isEmpty } from "lodash";

const AnswerRadio = ({ answer }) => {
  const answerDetails = answer?.answer?.other_details;

  return (
    <>
      {answerDetails?.radio_tag && (
        <View
          style={{
            marginBottom: "5px",
            alignSelf: "flex-start",
          }}
        >
          <Text
            style={{
              ...globalStyles.fontBold,
              backgroundColor: "#BEF9FF",
              padding: "5px 10px",
              borderRadius: "10px",
              display: "inline-block",
            }}
          >
            {answerDetails?.radio_tag}
          </Text>
        </View>
      )}
      <Text>
        {answer?.answer?.answer}
      </Text>
    </>
  );
};

export default AnswerRadio;
